import styled from 'styled-components';
import { Link } from 'react-router-dom';

export interface StepProps {
    step: number;
}

export const StepsContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing * 20}px;
`;

export const Step = styled.div<StepProps>`
    display: grid;
    grid-template-columns: 36px auto;
    grid-column-gap: 32px;
    width: 460px;
    margin-bottom: ${({ theme }) => theme.spacing * 12}px;
    position: relative;
    @media screen and (max-width: 600px) {
        width: auto;
    }

    &::after {
        width: 2px;
        height: ${( props ) => props.step !== 5 ? 'calc(100% + 48px)' : 0};
        position: absolute;
        top: 0;
        left: 17px;
        background-color: #2a71d426;
        content: '';
        z-index: -1;
    }
`;

export const StepNumber = styled.div`
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primary};
    line-height: 36px;
    text-align: center;
    color: #ffffffde;
    font-size: 14px;
    font-weight: bold;
`;

export const StepTitle = styled.h3`
    color: ${({ theme }) => theme.colors.grayAlpha};
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    margin: 0 0 ${({ theme }) => theme.spacing * 4}px 0;
`;

export const StepDescription = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.lightGrayAlpha};
    line-height: 26px;
    font-size: 14px;
`;

export const DotContainer = styled.div`
    display: grid;
    width: 81px;
    height: 81px;
    grid-template-columns: repeat(5, auto);
    grid-template-rows: repeat(5, auto);
    grid-gap: 9px;
    position: absolute;
    bottom: -36px;
    right: -36px;
`

export const Dot = styled.span`
    background-color: ${({ theme }) => theme.colors.primary};
    opacity: .15;
    border-radius: 50%;
`;

export const ImageWrapper = styled.div`
    width: 380px;
    height: 380px;
    position: relative;
    margin: ${({ theme }) => theme.spacing * 20}px auto 0;
    @media screen and (max-width: 1280px) {
        width: 200px;
        height: 200px
    }
    @media screen and (max-width: 960px) {
        display: none;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 80% 0;
    position: relative;
    z-index: 10;
    border-radius: 6px;
`;

export const StyledButton = styled(Link)`
    display: block;
    width: 198px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.white};
    background-color: #062B54;
    font-size: 12px;
    font-weight: bold;
    margin-left: ${({ theme }) => theme.spacing * 17}px;
    text-decoration: none;
`;

export const Button = styled.button`
    display: block;
    width: 198px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.white};
    background-color: #062B54;
    font-size: 12px;
    font-weight: bold;
    margin-left: ${({ theme }) => theme.spacing * 17}px;
    text-decoration: none;
    cursor: pointer;
    outline: none;
    border: none;
`;
